import type { UserProfile } from '../types/auth.types'

function isSuspensionActive(suspendedUntil: string | null, nowMs = Date.now()): boolean {
  if (!suspendedUntil) return true

  const untilMs = Date.parse(suspendedUntil)
  if (Number.isNaN(untilMs)) return true

  return untilMs > nowMs
}

export function isProfileRestricted(profile: UserProfile | null | undefined, nowMs = Date.now()) {
  if (!profile) return false
  if (profile.deletedAt) return true
  return profile.isSuspended && isSuspensionActive(profile.suspendedUntil, nowMs)
}

export function getRestrictionUntilMs(profile: UserProfile | null | undefined): number | null {
  if (!profile?.suspendedUntil) return null

  const untilMs = Date.parse(profile.suspendedUntil)
  return Number.isNaN(untilMs) ? null : untilMs
}
